import React from "react";
import { Button } from "@mui/material";
import { ChannelActions } from "@Store";
import { useDispatch } from "react-redux";
import { IChannel } from "@Interfaces";
import { actions as dialogActions } from "@Store/Reducers/dialog";
import { useIndexedDB } from "@Services/indexedDbClient";
import { Trans, useTranslation } from "react-i18next";

const DeleteChannelContent: React.FC<IChannel> = ({ title }) => {
    return (
        <>
            <Trans
                i18nKey="dialogs.delete_channel"
                values={{ title: title }}
                components={{ b: <b /> }}
            />
        </>
    );
};

const DeleteChannelActions: React.FC<IChannel> = (channel) => {
    const { t } = useTranslation();
    const { deleteRecord } = useIndexedDB("draftPoll");

    const dispatch = useDispatch<any>();
    const handleDeleteChannel = () => {
        dispatch(ChannelActions.deleteChannel(channel));
        dispatch(dialogActions.hideDialog());
        deleteRecord(channel._id);
    };

    return (
        <>
            <Button
                onClick={handleDeleteChannel}
                variant="contained"
                size="small"
                color="secondary"
                type="submit"
            >
                {t("dialogs.delete")}
            </Button>
        </>
    );
};

export default {
    content: DeleteChannelContent,
    actions: DeleteChannelActions,
    title: "Delete Event Channel",
};
